export const STATIC_PLAN_DATA = {
    'free': {
        tagline: 'Build your first algo strategy',
        list: [
            'Use credits for strategy ideation, code creation and backtesting.',
            'Full platform access, no restrictions.',
            'Access all markets and premium price data.'
        ],
        credit_usage: [
            {text: 'Build & download', highlight: '1 complete strategy'},
            {text: 'Save', highlight: '1 strategy'},
            {text: 'Generate up to', highlight: '1,000 lines of code'},
        ]
    },
    'builder': {
        tagline: 'For active traders refining and deploying strategies',
        list: [
            'Designed for users building and testing weekly',
            'Supports frequent prompt iterations and deeper backtesting',
            'Ideal for progressing from idea to live deployment'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: '5 trading strategies'},
            {text: 'Save', highlight: '20 strategies'},
            {text: 'Generate', highlight: '5,000 lines of code'},
        ]
    },
    'pro': {
        tagline: 'Built for systematic traders scaling up automation',
        list: [
            'Designed for traders optimising multiple live strategies',
            'Built to support high-frequency AI testing workflows',
            'Priority credit queueing for faster generation & backtesting'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: '15 trading strategies'},
            {text: 'Save', highlight: '50 strategies'},
            {text: 'Generate', highlight: '15,000 lines of code'},
        ]
    },
    'quant': {
        tagline: 'Unlimited AI firepower for systematic traders and pros',
        list: [
            'Unlimited credits for ideation, code generation & backtesting',
            'Highest priority processing queue',
            'Strategy versioning and long-form prompt support',
            'Ideal for trading desks, quant teams & algo pros'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: 'unlimited trading strategies'},
            {text: 'Save', highlight: 'Unlimited strategies'},
            {text: 'Generate', highlight: 'Unlimited lines of code'},
        ]
    },
    'sponsor-sm': {
        tagline: 'For active traders refining and deploying strategies',
        list: [
            'Designed for users building and testing weekly',
            'Supports frequent prompt iterations and deeper backtesting',
            'Ideal for progressing from idea to live deployment'
        ],
        credit_usage: [
            {text: 'Build, optimise & download', highlight: '5 trading strategies'},
            {text: 'Save', highlight: '20 strategies'},
            {text: 'Generate', highlight: '5,000 lines of code'},
        ]
    }
};
